import { Loading } from '@/components/Loading'
import Step2Wrapper from '@/containers/steps/vehicle/Step2/Step2Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import OffersAddonProvider from '@/context/OffersAddonProvider'
import { QuotesProvider } from '@/context/QuotesContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { WithAuth } from '@/hoc/WithAuth'
import { useInsurers } from '@/hooks'
import { useSaveBaseInsuranceParams } from '@/hooks/useWizardAddon'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { PageAlert } from 'BrokerTsLib/src/components'
import { useEffect, useMemo, useRef, useState } from 'react'

const Step2PageComponent = () => {
  const { insuranceParams, isLoadingData, refetchInsuranceParams } = useInsuranceParams()
  const ipDto = insuranceParams as InsuranceParamsDto
  const insurersLength = ipDto?.baseParams?.addonInsurers?.length ?? 0
  const { mutateAsync: saveBaseInsuranceParams, isPending: isLoadingSaveBaseParams } = useSaveBaseInsuranceParams()

  const existInsurers = useMemo(() => insurersLength > 0, [insurersLength])

  const { isLoading: isLoadingAddonInsurers, refetch, data: insurersData } = useInsurers(true, false, {
    enabled: false,
  })

  // ochrana proti zacykleni - ulozeni pojistoven zkousime pouze jednou
  const saveBaseParamsAttempted = useRef(false)
  const [addonsUnavailable, setAddonsUnavailable] = useState(false)

  useEffect(() => {
    if (insurersData && ipDto && !isLoadingData && !isLoadingSaveBaseParams && !existInsurers && !saveBaseParamsAttempted.current) {
      const data = insurersData.data
      if (data.length === 0) {
        setAddonsUnavailable(true)
        return
      }

      saveBaseParamsAttempted.current = true
      const newAddonInsurers = data.map(x => x.id)

      saveBaseInsuranceParams({
        ...ipDto,
        baseParams: {
          ...ipDto.baseParams,
          addonInsurers: newAddonInsurers,
        }
      })
        .then(async (response) => {
          if (response.data) {
            const refetched = await refetchInsuranceParams()
            const refetchedDto = refetched.data?.data as InsuranceParamsDto | undefined
            if (refetchedDto?.baseParams?.addonInsurers?.length)
              return
          }
          setAddonsUnavailable(true)
        })
    }
  }, [insurersData, existInsurers, ipDto, isLoadingData, isLoadingSaveBaseParams, saveBaseInsuranceParams, refetchInsuranceParams])

  useEffect(() => {
    if (insuranceParams)
      refetch()
  }, [insuranceParams])

  const isLoading = !addonsUnavailable && (isLoadingData || isLoadingAddonInsurers || isLoadingSaveBaseParams || !existInsurers)

  return (
    <StepsProvider currentStepId={2}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <QuotesProvider>
            {addonsUnavailable &&
              <PageAlert status="warning" title="Pojištění doplňků není dostupné">
                Pro tuto nabídku nelze sjednat žádné doplňkové pojištění.
              </PageAlert>
            }
            {isLoading && <Loading large={true} />}
            {!isLoading && ipDto &&
              <OffersAddonProvider>
                <Step2Wrapper />
              </OffersAddonProvider>
            }
          </QuotesProvider>
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step2Page = WithAuth(Step2PageComponent)